import React, { useCallback, useEffect, useState } from "react";
import styles from "../../styles/components/createBotFirst.module.scss";
import secondStyles from "../../styles/pages/createSecondPage.module.scss";
import Icons from "../../public/assets/svg";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Router from "next/router";
import DropDown from "../listWithoutcheck";
import { firstBotCreateAction } from "../../redux/createBot/actions";
import { useDispatch, connect } from "react-redux";
import _get from "lodash/get";
import UploadDocuments from "../uploadDocuments";
import _ from "lodash";
import authReducer from "./../../redux/auth/reducer";
import endpoint from "../../utility/endpoints.js";
import axios from "axios";
import CheckboxDropdown from "../listDropdown";
import Loader from "../Loader"
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions.js";
import { bindActionCreators } from "redux";
import skeleton_style from "../shared/skeleton.module.css";
import { config as axiosConfig } from "../shared/config.js";
import { toast } from "react-toastify";
import CreateETForm from "./CreateETForm.jsx";

function index(props) {
  // to convert labels into camelcase
  //console.log(props.data,"savedState");

  const [auth, setAuth] = useState({});
  const [allBotFields, setAllBotFields] = useState([]);
  const [requiredFieldsArray, setRequiredFieldsArray] = useState([]);

  //console.log(props, "props at create bot");


 // let emailCheck = [];
  let initialStates = {};
  let dropDownsInitialStates = {};

  const [emailCheck, setEmailCheck] = React.useState([])
  const [requiredFields, setRequiredFields] = React.useState([])
  const [numberCheck, setNumberCheck ]  = React.useState([])
  const [loading, setloading ] = React.useState(false)

  //for emails searching
  const [query, setQuery] = useState("");
  const [prevEmail, setPrevEmail] = useState("");
  const [results, setResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

   //for cost approver
  const [query2, setQuery2] = useState("");
  const [prevEmail2, setPrevEmail2] = useState("");
  const [results2, setResults2] = useState([]);
  const [isSearching2, setIsSearching2] = useState(false);
  
    //for business analyst
  const [baQuery, setBaQuery] = useState("");
  const [prevBaEmail, setPrevBaEmail] = useState("");
  const [baResults, setBaResults] = useState([]);
  const [baIsSearching, setBaIsSearching] = useState(false);

  //create ET in Bot form
  const [newlyCreatedET, setNewlyCreatedET] = useState("");

  React.useEffect(() => {
    // popping some stuff out (dangerous change this while refactoring)
    if (props.pageNum == 2) {
      for (let i in props.data) {
        if (i == 8) {
          props.data.pop();
        }
      }
    }

    setAuth(JSON.parse(localStorage.getItem("auth")).data);
    props.data.map((item) => {
      //console.log("jjjjjjj",item)
      if (item.field_label == "MCO") {
        item.value = "mco";
      }else if (item.field_label == "Technology") {
        //april 2024
        item.value = "technology";
      }else if (item.field_label == "SOP Received date") {
        item.value = "sopReceivedDate";
      } else if (item.field_label == "PDD Sign off date") {
        item.value = "pddSignOffDate";
      } else if (item.field_label == "BAU date") {
        item.value = "bauDate";
      }else if (item.field_label == "Landscape") {
        item.value = "landscape";
      } else if (item.field_label == "Application") {
        item.value = "applications";
      } else if (item.field_label == "KFAS") {
        item.value = "kfa";
      } else if (item.field_label == "KFAS Type") {
        item.value = "kfaType";
      } else if (item.field_label == "Parent Bot ID") {
        item.value = "parentBotID";
      } else if (item.field_label == "Status") {
        item.value = "status";
      } else {
        item.value = camelize(item.field_label);
      }
    });

    props.data.map((item) => {
      if (
        item.field_input_type == "Related Dropdown" &&
        item.field_related_dropdown.length > 0
      ) {
        let fieldOptions = [];
        item.field_dropdown_option_component.map((item) => {
          fieldOptions = [...fieldOptions, ...item.field_options];
        });
      }
    });

   let emailCheckAr = []
  
   let numberCheckAr = []
   let requiredFields = [];

    props.data.map((item) => {
      initialStates["kfaTransactional"] = false;
      initialStates["kfaInformational"] = false;
     

      if (item.field_required == "1") {
        if (item.field_label == "Country") {
          initialStates[item.value] = [];
        }else if (item.field_label == "Technology") {
          initialStates["technology"] = [];
        }else if (item.field_label == "KFAS") {
          initialStates["kfa"] = false;
     {/*   }else if (item.field_label == "Catalogue Products") {
          initialStates["catalogueProducts"] = false; */}
        } else if (item.value == "requestType") {
          initialStates[item.value] = "New Request";
        } else if (item.value == "createdBy") {
          // alert("ui")
          let AuthName = JSON.parse(localStorage.getItem("auth")).data;
          initialStates[item.value] = AuthName.name ? AuthName.name : AuthName.email;
        } else if (item.value == "dateLogged") {
          initialStates[item.value] = formatDate();
        } else if (item.value == "supportStatus") {
          initialStates[item.value] = "PGLS";
        }  else {
          // initialStates[item.value] = "";
        }
      }

      if (
        item.field_input_type == "Dropdown" ||
        item.field_input_type == "Related Dropdown"
      ) {
        dropDownsInitialStates[item.value] = false;
      }
      if (item.field_required == "1") {
        if (
          item.value != "dateOfStatusChanged" &&
          item.value != "commentsForStatusChanged" &&
          item.value != "goLiveDate"
        ) {
          requiredFields.push(item.value);
        }
      }

      if (item.field_input_type == "Number") {
        numberCheckAr.push(item.value);
      }
      if (item.field_input_type == "Email") {
        emailCheckAr.push(item.value);
      }
    });

    if (props.savedState.landscapeApproval !== undefined && props.savedState.landscapeApproval !== null) {
        
      if (props.savedState.landscapeApproval && props.savedState.landscapeApproval !== "No"){
      props.savedState.landscapeApproval = "Yes"; }
     else {
      props.savedState.landscapeApproval = "No";
      emailCheckAr = emailCheckAr.filter((item) => item != "landscapeApprover")
      requiredFields = requiredFields.filter((item) => item != "landscapeApprover")
      
      props.data.map((item) => {
        if (item.value == "landscapeApprover") {
         
          item.field_required = "0";
        }
      });

    }
  }
  if (props.savedState.infosecApproval !== undefined && props.savedState.infosecApproval !== null) {


    if (props.savedState.infosecApproval && props.savedState.infosecApproval !== "No") {
    
      props.savedState.infosecApproval = "Yes";
    } else {
     
      props.savedState.infosecApproval = "No";
      emailCheckAr = emailCheckAr.filter((item) => item != "infosecApprover")
      requiredFields = requiredFields.filter((item) => item != "infosecApprover")
         
      props.data.map((item) => {
        if (item.value == "infosecApprover") {
         
          item.field_required = "0";
        }
      });
     
    }
  }

  //console.log(requiredFields, "EMAILtopCheck", emailCheckAr)
    setRequiredFieldsArray([...requiredFields]);

    setAllBotFields(props.data);

    setEmailCheck([...emailCheckAr])
    setNumberCheck([...numberCheckAr])
  }, []);

  function formatDate() {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  function validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    if ( re.test(String(email).toLowerCase())) {
      let emailAr =  email.split('@')
      if (emailAr.length == 2) {
        if (emailAr[1] == "unilever.com"){
         return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }

    }
    else {
      return false
    }
  

     // return re.test(String(email).toLowerCase());
  }

  function camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  // saving bots camalcased label as value

  const [relatedDropdowns, setRelatedDropdowns] = React.useState(null);



  React.useEffect(() => {
    // debugger
    props.data.map((item, index) => {
      if (item.field_label == "Status") {
        let AuthName = JSON.parse(localStorage.getItem("auth")).data;
        if (AuthName.userType != "qrManager") {
          item.field_options = item.field_options.filter(
            (item) => item !== "Live"
          );
        }
      }
    });
    let relatedDropdownToSet = {};
    props.data.map((item) => {
      if (item.field_input_type == "Related Dropdown") {
        relatedDropdownToSet = {
          ...relatedDropdownToSet,
          [item.value]: { allValues: item.field_dropdown_option_component },
        };
      }
    });

    props.data.map((item) => {
      
      if (
        item.field_related_dropdown !== "" &&
        item.field_related_dropdown !== null &&
        item.field_related_dropdown !== undefined
      ) {
        if ( !_.isEmpty(props.savedState)) {
          //console.log(props.savedState.country, "countryy");
        //console.log("====>#1",relatedDropdownToSet["mco"])
        //console.log("====>#11",camelize(item.field_related_dropdown))
          
          if (
            relatedDropdownToSet[
              camelize(item.field_related_dropdown) == "mCO"
                ? "mco"
                : camelize(item.field_related_dropdown)
            ] !== undefined
          ) {
            //console.log(relatedDropdownToSet,"savedState");
            let nowValuesArr = relatedDropdownToSet[
              camelize(item.field_related_dropdown) == "mCO"
                ? "mco"
                : camelize(item.field_related_dropdown)
            ].allValues.filter(
              (innerItem) =>
              (camelize(item.field_related_dropdown)=="country")?props.savedState[item.value].includes(innerItem.field_title):
                innerItem.field_title == props.savedState[item.value]
            );

               //console.log("====>#2",props.savedState[item.value])
               //console.log("====>#3",nowValuesArr)

            if(nowValuesArr.length>0){
             var nowValues = []
             nowValuesArr.map((val)=>{
              nowValues.push(...val.field_options)
             })
            }
            //console.log("====>#4",nowValues)
            //console.log(nowValues,"relatedDropdownToSet");
            relatedDropdownToSet[
              camelize(item.field_related_dropdown) == "mCO"
                ? "mco"
                : camelize(item.field_related_dropdown)
            ].nowValues = nowValues;
          }
        }
      }
    });

    //   props.data.map((item, index) => {
    //     if (item.field_related_dropdown !== "" && item.field_related_dropdown !== null && item.field_related_dropdown !== undefined){
    //         console.log(relatedDropdowns, "RELATEDdROPDOWN")
    //     }
    //  })

    setRelatedDropdowns(relatedDropdownToSet);
  }, []);

  const [state, setState] = React.useState(initialStates);

  const [dropDownState, setDropdownState] = React.useState(
    dropDownsInitialStates
  );

  const [invalidFlag, setInvalidFlag] = React.useState(false);
  const [sopInvalid, setSopInvalid] = React.useState(false);

  const dispatch = useDispatch();

  let inputprops = {
    placeholder: "DD-MM-YYYY",
    readOnly: true,
  };

  const botback = () => {
    Router.push("/botStore");
  };

  const callCreateBoApi = async (boEmail) => {

    let auth = JSON.parse(localStorage.getItem("auth")).data;
    
    try {
      let authCheck = await JSON.parse(localStorage.getItem("auth")).data;

      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        
      
      const botResponse = await axios({
        method: "POST",
        url: `${endpoint.baseUrl}${endpoint.createBO}`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
        data: {
          email: boEmail,
          
        },
      });
      return botResponse;
    }
    else {
      setloading(false)
      props.sessionTimeOutCheck(true)
    }
    } catch (e) {
      console.log("failed to create bo");
    }
  };

  const botSecond = async () => {
    // props.pagenume1  ==
    
    //console.log(emailCheck, "emailCHeck")

     console.log("formState", state);
     console.log('pageNum', props.pageNum);

 
    if (props.pageNum == 1 && state.businessOwnerEmailID) {
     
      let boEmail = state.businessOwnerEmailID;
      setloading(true)
      let boResposne = await callCreateBoApi(boEmail);
        setloading(false)
      if (boResposne.data.code == 401) {
        // failure modal true
        //
        props.setBusinessOwnerModal(true);
        return;
      }
      else if (boResposne.data.code == 403) {
        setloading(false)
        props.sessionTimeOutCheck(true);
        props.setBusinessOwnerModal(false);
      }
      else {
        props.setBusinessOwnerModal(false);
      }
    }

    let moveAhead = true;
  
    if (state["requestType"] == "New Request") {
      let requiredFieldsChange = requiredFieldsArray.filter(
        (item) => item != "parentBotID"
      );
      setRequiredFieldsArray([...requiredFieldsChange]);
    }

    //console.log(requiredFieldsArray, "1234");
    //console.log(state,"1234" )
    for (let i in requiredFieldsArray) {

     
      if ( typeof state[requiredFieldsArray[i]] == "string"  ){
      if (
        state[requiredFieldsArray[i]].trim() === "" ||
        state[requiredFieldsArray[i]].trim() === undefined ||
        state[requiredFieldsArray[i]].trim() == undefined ||
        state[requiredFieldsArray[i]].trim() == "undefined" ||
        state[requiredFieldsArray[i]].trim() == null 
      ) {
      
       
        moveAhead = false;
        break;
      }
    }

    else if (  
       state[requiredFieldsArray[i]] === "" ||
      state[requiredFieldsArray[i]] === undefined ||
      state[requiredFieldsArray[i]] == undefined ||
      state[requiredFieldsArray[i]] == "undefined" ||
      state[requiredFieldsArray[i]] == null 
     ) {
      moveAhead = false;
      break;
     }


  }

    for (let i in numberCheck) {
      if (isNaN(state[numberCheck[i]])) {
        moveAhead = false;
        break;
      }
    }

    //console.log(emailCheck, "emailCHeck")

    for (let i in emailCheck) {
      if (!validateEmail(state[emailCheck[i]]) && state[emailCheck[i]]) {
        //console.log(state[emailCheck[i]] , "baadlater")
        moveAhead = false;
      }
    }

    if (props.pageNum == 2) {
      if (state.sopDocument != null && state.sopDocument != undefined) {
        if (state.sopDocument.length < 1) {
          moveAhead = false;
          setSopInvalid(true);
        }
      } else {
        setSopInvalid(true);
        moveAhead = false;
      }
    }

    if (
      state["kfa"] == true &&
      state["kfaTransactional"] == false &&
      state["kfaInformational"] == false 
      
    // && state["kfaIuc"] == false
    ) {
      moveAhead = false;
    }
    if (
      state["catalogueProducts"] == undefined
    ) {
      moveAhead = false;
    }
    if (moveAhead) {
      // setInvalidFieldValidate(initialState);
      //console.log(state, "state is all I need")
      props.saveInfoToRedux(state, props.pageNum);
      // dispatch(firstBotCreateAction(state));
      if (props.pageNum == 4) {
        props.allDone();
      } else {
        props.nextBot(props.pageNum + 1);
      }

      // Router.push("/createBotSecondPage");
    } else {
      setInvalidFlag(true);
    }
  };

  const goBack = () => {
    props.nextBot(props.pageNum - 1);
  };

  //for email searching

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  //for email searching
  const searchEmails = useCallback(
    debounce(async (query) => {
      if (!query) return setResults([]);

      const config = {
        headers: {
          Authorization: `Bearer ${axiosConfig.bearerToken}`,
        },
        params: {
          text: query,
        },
      };
      setIsSearching(true);
      try {
        const res = await axios.get(
          `${axiosConfig.baseUrl}/pinterest/getAllUsers`,
          config
        );

        if (res.data?.message === "Error while authentication") {
          toast.warning("Session Expired, Please refresh");
        }

        if (res.data?.users?.length) {
          setResults(res.data.users);
        }
        setIsSearching(false);
      } catch (error) {
        setIsSearching(false);
        console.error("Error fetching emails:", error);
      }
    }, 500), // 500ms debounce delay
    []
  );

  
    //for cost approver
  const searchEmails2 = useCallback(
    debounce(async (query2) => {
      if (!query2) return setResults2([]);

      const config = {
        headers: {
          Authorization: `Bearer ${axiosConfig.bearerToken}`,
        },
        params: {
          text: query2,
        },
      };
      setIsSearching2(true);
      try {
        const res = await axios.get(
          `${axiosConfig.baseUrl}/pinterest/getAllUsers`,
          config
        );

        if (res.data?.message === "Error while authentication") {
          toast.warning("Session Expired, Please refresh");
        }

        if (res.data?.users?.length) {
          setResults2(res.data.users);
        }
        setIsSearching2(false);
      } catch (error) {
        setIsSearching2(false);
        console.error("Error fetching emails:", error);
      }
    }, 500), // 500ms debounce delay
    []
  );

  //for business analyst
  const searchBusinessAnalyst = useCallback(
    debounce(async (baQuery) => {
      if (!baQuery) return setBaResults([]);

      const config = {
        headers: {
          Authorization: `Bearer ${axiosConfig.bearerToken}`,
        },
        params: {
          text: baQuery,
        },
      };
      setBaIsSearching(true);
      try {
        const res = await axios.get(
          `${axiosConfig.baseUrl}/pinterest/getAllUsers`,
          config,
        );

        if (res.data?.message === "Error while authentication") {
          toast.warning("Session Expired, Please refresh");
        }

        if (res.data?.users?.length) {
          setBaResults(res.data.users);
        } else {
          setBaResults([]);
        }
        setBaIsSearching(false);
      } catch (error) {
        setBaIsSearching(false);
        console.error("Error fetching emails:", error);
      }
    }, 500), // 500ms debounce delay
    [],
  );


  //for email searching
  const setBusinessOwnerEmail = (e) => {
    setPrevEmail(e.target.value);
    setTimeout(() => {
      setQuery(e.target.value);
    }, 500);
    inputChange(e);
    setResults([]);
  };

   //for cost approver
  const setCostApprover = (e) => {
    setPrevEmail2(e.target.value);
    setTimeout(() => {
      setQuery2(e.target.value);
    }, 500);
    inputChange(e);
    setResults2([]);
  };


  //for business analyst
  const setBusinessAnalyst = (e) => {
    setPrevBaEmail(e.target.value);
    setTimeout(() => {
      setBaQuery(e.target.value);
    }, 500);
    inputChange(e);
    setBaResults([]);
  };

  const inputChange = (e) => {
    //console.log("e.target.name:",e.target.name)
    //console.log("e.target.value:",e.target.value)
    if (e.target.name == "kfa") {
      if (e.target.value == "Yes") {
        setState({ ...state, kfa: true });
      } else {
        setState({
          ...state,
          kfa: false,
          kfaInformational: false,
          kfaTransactional: false,
         // kfaIuc: false,
        });
      }
    } 
    else if (e.target.name == "catalogueProducts") {
      if (e.target.value == "Yes") {
        setState({ ...state, catalogueProducts: true });
      } else {
        setState({
          ...state,
          catalogueProducts: false,
        });
      }
    } 
    else if (e.target.name == "kfaType") {
      if (e.target.value == "Transactional") {
        setState({
          ...state,
          kfaTransactional: true,
          kfaInformational: false,
        //  kfaIuc: false,
        });
      } else if (e.target.value == "Informational") {
        setState({
          ...state,
          kfaTransactional: false,
          kfaInformational: true,
        //  kfaIuc: false,
        });
      } else {
        setState({
          ...state,
          kfaTransactional: false,
          kfaInformational: false,
        //  kfaIuc: true,
        });
      }
    } else {
      if (e.target.name == "requestType") {
        if (e.target.value == "New Request") {
          let requiredFields = requiredFieldsArray;
          let requiredArToChange = requiredFields.filter(
            (item, index) => item !== "parentBotID"
          );
          setRequiredFieldsArray(requiredArToChange);
        } else {
          let requiredFields = requiredFieldsArray;
          requiredFields.push("parentBotID");
          setRequiredFieldsArray(requiredFields);
        }
      }

      setState({ ...state, [e.target.name]: e.target.value });
    }
  };
  const hanldelinputBlur =async (e)=>{
    if(e.target.name=="parentBotID"){
      const botResponse = await axios({
        method: "POST",
        url: `${endpoint.baseUrl}${endpoint.getBotIdByExtID}`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
        data: {
          id: e.target.value,
        },
      });
      //console.log("botResponse",botResponse.data.data.botID)
      setState({ ...state, [e.target.name]: botResponse.data.data.botID });
    }
  }

  const handleDropDown = (item) => {
    // if (props.formType == "editBot") {
    if (auth.userType != "supportStatus") {
      if (item == "supportStatus") {
        return;
      }
    }

    //}
    setDropdownState({
      ...dropDownsInitialStates,
      [item]: !dropDownState[item],
    });
  };

  const gotDropDownValue = (value, dropdownParent, haveRelated , checkbox) => {
    //console.log("========>1",value)
    //console.log("========>2",dropdownParent)
    //console.log("========>3", haveRelated)
    //console.log("========>4", checkbox)
    if (value == "None") {
      if (dropdownParent == "country") {
        setState({ ...state, [dropdownParent]: [] });
      } else {
        let newState = state;
        delete newState[dropdownParent];
        setState({ ...newState });
      }
    } else {
      if (dropdownParent == "status") {
        //console.log(value, "valuessToBeAttatchedToForLIFE")
        
        if (value == "Retired" || value == "On hold" || value == "Rejected") {
          setRequiredFieldsArray([
            ...requiredFieldsArray,
            "commentsForStatusChanged",
          ]);
          //  let dateToday = formatDate()
          // console.log(dateToday)
          setState({
            ...state,
            ["dateOfStatusChanged"]: formatDate(),
            [dropdownParent]: value,
          });
          //console.log({ ...state, ["dateOfStatusChanged"]: formatDate() });
        } else {
          if (value == "Live") {
            setRequiredFieldsArray([...requiredFieldsArray, "goLiveDate"]);
          } else {
            let requiredFieldsFiltered = requiredFieldsArray.filter(
              (item) => item != "goLiveDate"
            );
            setRequiredFieldsArray([...requiredFieldsFiltered]);
          }

          let requiredFieldsFiltered = requiredFieldsArray.filter(
            (item) =>
              item != "dateOfStatusChanged" &&
              item != "commentsForStatusChanged"
          );
          setRequiredFieldsArray([...requiredFieldsFiltered]);
          let stateToChange = state;
          delete stateToChange["dateOfStatusChanged"];
          setState({ ...stateToChange, [dropdownParent]: value });
        }
      } else if (dropdownParent == "landscapeApproval") {
        if (value == "Yes") {
          setRequiredFieldsArray([...requiredFieldsArray, "landscapeApprover"]);
          setEmailCheck([...emailCheck, "landscapeApprover"])
          setState({ ...state, [dropdownParent]: value });
          let updatedFields = allBotFields;
          updatedFields.map((item) => {
            if (item.value == "landscapeApprover") {
             
              item.field_required = "1";
            }
          });
          setAllBotFields([...updatedFields]);
        } else {
          let requiredFieldsFiltered = requiredFieldsArray.filter(
            (item) => item != "landscapeApprover"
          );

         let emailCheckArNow = emailCheck.filter((item) => item != "landscapeApprover")
          setRequiredFieldsArray([...requiredFieldsFiltered]);
          setEmailCheck([...emailCheckArNow])
         // let stateToChange = state;
         // delete stateToChange["landscapeApprover"];
          setState({ ...state, [dropdownParent]: value, landscapeApprover : "" });

          let updatedFields = allBotFields;
          updatedFields.map((item) => {
            if (item.value == "landscapeApprover") {
              //console.log(item, "itemmm");
              item.field_required = "0";
            }
          });
          setAllBotFields([...updatedFields]);
        }
      } else if (dropdownParent == "infosecApproval") {
        if (value == "Yes") {
          setRequiredFieldsArray([...requiredFieldsArray, "infosecApprover"]);
          setState({ ...state, [dropdownParent]: value });
          setEmailCheck([...emailCheck, "infosecApprover"])

          let updatedFields = allBotFields;
          updatedFields.map((item) => {
            if (item.value == "infosecApprover") {
              item.field_required = "1";
            }
          });
          setAllBotFields([...updatedFields]);
        } else {
          let requiredFieldsFiltered = requiredFieldsArray.filter(
            (item) => item != "infosecApprover"
          );
          let emailCheckArNow = emailCheck.filter((item) => item != "infosecApprover")
          setRequiredFieldsArray([...requiredFieldsFiltered]);
          setEmailCheck([...emailCheckArNow])

         // let stateToChange = state;
         // delete stateToChange["infosecApprover"];
          setState({ ...state, [dropdownParent]: value, infosecApprover : "" });

          let updatedFields = allBotFields;
          updatedFields.map((item) => {
            if (item.value == "infosecApprover") {
              item.field_required = "0";
            }
          });
          setAllBotFields([...updatedFields]);
        }
      } else {
        if (haveRelated != null && haveRelated.length > 0) {
          let newState = state;
          delete newState[haveRelated];

         let myArr =  props.data.filter((item)=> item.value==haveRelated)
         
          if(myArr.length>0){
            if(myArr[0].field_related_dropdown){
              var emptyNowValues = camelize(myArr[0].field_related_dropdown)

            } 
          }

          props.data.map((item, index) => {
            if (item.value == haveRelated) {
              if (
                camelize(item.field_related_dropdown) != null &&
                camelize(item.field_related_dropdown).length > 0
              ) {
                //  let newerState = state
                if (camelize(item.field_related_dropdown) == "country") {
                  newState["country"] = [];
                  newState["mco"] = [];
                }
                else {
                  delete newState[camelize(item.field_related_dropdown)];
                }
              }
            }
          });

          setState(newState);

          //console.log(relatedDropdowns, "related Ka Khel");
          let selectedRelatedDropdown = relatedDropdowns;
            // selectedRelatedDropdown[haveRelated].nowValues =
            // selectedRelatedDropdown[haveRelated].allValues.filter(
            //   (item) => item.field_title == value
            // )[0].field_options;
          selectedRelatedDropdown[haveRelated].nowValues =""


          if (Array.isArray(value)) {
            console.log("running first if");
            let arr = [];
            selectedRelatedDropdown[haveRelated].allValues
              .filter((item) => {
                return value.includes(item.field_title);
              })
              .map((va, index) => arr.push(...va.field_options));
            selectedRelatedDropdown[haveRelated].nowValues = arr;
          } else {
            //ET Profile
            if (dropdownParent === "technology" && value !== "ET") {
              console.log("running do nothing for direct check");

              if (state["technology"].includes("ET")) {
                console.log("fetch dropdown values of ET Profile");

                selectedRelatedDropdown[haveRelated].nowValues =
                  selectedRelatedDropdown[haveRelated].allValues.filter(
                    (item) => item.field_title == "ET"
                  )[0].field_options;
              }
            } else {
              console.log("running else one");
              selectedRelatedDropdown[haveRelated].nowValues =
                selectedRelatedDropdown[haveRelated].allValues.filter(
                  (item) => item.field_title == value
                )[0].field_options;
            }
          }

            if(emptyNowValues){
              delete selectedRelatedDropdown[emptyNowValues].nowValues
             }

          setRelatedDropdowns({ ...selectedRelatedDropdown });
        }

        if (dropdownParent == "country") {
          let repeatedFlag = false;
          // alert(value+"==="+JSON.stringify(state[dropdownParent]))
          for (let i in state[dropdownParent]) {
            if (state[dropdownParent][i] == value) {
              repeatedFlag = true;
              break;
            }
          }
          if (!repeatedFlag) {
            // console.log("state[dropdownParent]",state[dropdownParent])
            setState({
              ...state,
              [dropdownParent]: [...state[dropdownParent], value],
            });
          }
          // setState({ ...state, [dropdownParent]: [value] });
          
        }
        // else if (dropdownParent == "mco") {
          // setState({ ...state, [dropdownParent]: value, country: [] });
        else if (dropdownParent == "mco") {
          let repeatedFlag = false;
          for (let i in state[dropdownParent]) {
            if(Array.isArray(value)){
              if (state[dropdownParent][i] == value[value.length-1]) {
                repeatedFlag = true;
                break;
              }
            }else{
              if (state[dropdownParent][i] == value ) {
                repeatedFlag = true;
                break;
              }
            }
          }
          if (!repeatedFlag) {
            if(Array.isArray(value)){
              setState({
                ...state,
                [dropdownParent]: [...state[dropdownParent],value[value.length-1]],country: []
              });
            }else{
              setState({
                ...state,
                [dropdownParent]: [...state[dropdownParent], value],country: []
              });
            }
          }
          // setState({ ...state, [dropdownParent]: [value] });
          
        } else if (dropdownParent == "technology") {
          //april 2024

          let repeatedFlag = false;

          for (let i in state[dropdownParent]) {
            if (state[dropdownParent][i] == value) {
              repeatedFlag = true;
              break;
            }
          }
          if (!repeatedFlag) {
            setState({
              ...state,
              [dropdownParent]: [...state[dropdownParent], value],
            });
          }
        } else {
          setState({ ...state, [dropdownParent]: value });
        }
      }
    }
    if (!checkbox) {
      setDropdownState(dropDownsInitialStates);
    }
  };

React.useEffect(() => {
   //console.log(state.mco, "========>stateisAllineed")
}, [state])


  const handleDate = (date, parent) => {
    if (typeof date == "object") {
      var bigDate = date._d;
      var dd = String(bigDate.getDate()).padStart(2, "0");
      var mm = String(bigDate.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = bigDate.getFullYear();
      const myDate = yyyy + "-" + mm + "-" + dd;

      setState({ ...state, [parent]: myDate });
    } else {
      setState({ ...state, [parent]: date._d });
    }
  };

  const convertToDDMMYYYY = (date, Z) => {
    let year = date.slice(0, 4);
    let month = date.slice(5, 7);
    let day = date.slice(8, 10);

    let newDate = day + "-" + month + "-" + year;
    return newDate;
  };

  React.useEffect(() => {
    //console.log("props.savedState",props.savedState)
    if (props.savedState) {

      if (props.savedState.country) {
        if (typeof props.savedState.country == "string") {
          props.savedState.country = props.savedState.country.split(",");
          if (props.savedState.country[props.savedState.country.length-1] == ""){
            props.savedState.country.pop()
          }
        }
      }
      if (props.savedState.mco) {
        if (typeof props.savedState.mco == "string") {
          props.savedState.mco = props.savedState.mco.split(",");
          if (props.savedState.mco[props.savedState.mco.length-1] == ""){
            props.savedState.mco.pop()
          }
        }
      }



      //technology 4/12/24
      if (props.savedState.technology) {
        if (typeof props.savedState.technology == "string") {
          props.savedState.technology = props.savedState.technology.split(",");
          if (
            props.savedState.technology[
              props.savedState.technology.length - 1
            ] == ""
          ) {
            props.savedState.technology.pop();
          }
        }
      }
      



          // props.savedState.parentBotID = props.savedState.botID;
        
        
        

   
      // console.log(emailCheckNowAr, "EMAILTopCHECK", requiredArToChangeNow)
      // setEmailCheck([...emailCheckNowAr])
      // setRequiredFields([...requiredArToChangeNow])

      setState({ ...state, ...props.savedState });
    }
  }, []);

  const gotDocInfo = (name, url, extension) => {
    //console.log(url, "tera dhiyaan kidhar hai, url idhar hai", extension);
    setState({ ...state, [name]: url});
  };

  const gotUploadDocumentsState = (uploadDocumentsState, presentState) => {
    setState({ ...state,...presentState, uploadDocumentsState });
  };

  const deleteDemoVideo = () => {
    state.botDemoVideo = "";
  };

  const removeCheckedValue = (option, dropdownParent,haveRelated) => {
    if(dropdownParent=="mco"){
      //console.log("removedChecked Value",option,dropdownParent,haveRelated)
      let changedCheckBoxAr =  state[dropdownParent].filter((item) => item != option)
      let selectedRelatedDropdown = relatedDropdowns;
      let arr=[] 
      selectedRelatedDropdown[haveRelated].allValues.filter(
        (item) => {
          return changedCheckBoxAr.includes(item.field_title)
          //  item.field_title == value
        }
        ).map((va,index)=>arr.push(...va.field_options));
      selectedRelatedDropdown[haveRelated].nowValues=arr
      setRelatedDropdowns({ ...selectedRelatedDropdown });

      setState({
        ...state,
        [dropdownParent] : [...changedCheckBoxAr],country:[]
      })
    }else{
      let changedCheckBoxAr =  state[dropdownParent].filter((item) => item != option)
      setState({
        ...state,
        [dropdownParent] : [...changedCheckBoxAr]
      })
      //console.log("removedChecked Value 1",changedCheckBoxAr)
    }
    }

   //create ET in Bot form
  const closeETForm = () => {
    setState((prev) => ({ ...prev, eTProfile: "", technology: [] }));
  };
 

 //for email searching

  const { businessOwnerEmailID } = state;

  useEffect(() => {
    if (props.formType === "editBot") {
      setQuery(state.businessOwnerEmailID);
    }
  }, [businessOwnerEmailID]);

  useEffect(() => {
    if (props.pageNum == 1) {
      if (prevEmail !== query) {
        searchEmails(query);
      }
      if (
        query === "" &&
        props.formType !== "createRollout" &&
        props.formType !== "editBot"
      ) {
        setState({ ...state, businessOwnerEmailID: "" });
      }
    }
  }, [query, searchEmails]);


   //for cost approver start
  const { costApprover } = state;

  useEffect(() => {
    if (props.formType === "editBot") {
      setQuery2(state.costApprover);
    }
  }, [costApprover]);

    //for business analyst start
  const { businessAnalyst } = state;

  useEffect(() => {
    if (props.formType === "editBot") {
      setBaQuery(state.businessAnalyst);
    }
  }, [businessAnalyst]);


  useEffect(() => {
    if (props.pageNum == 1) {
      if (prevEmail2 !== query2) {
        searchEmails2(query2);
      }
      if (
        query2 === "" &&
        props.formType !== "createRollout" &&
        props.formType !== "editBot"
      ) {
        setState({ ...state, costApprover: "" });
      }
    }
  }, [query2, searchEmails2]);
  //for cost approver end

 useEffect(() => {
    if (props.pageNum == 1) {
      if (prevBaEmail !== baQuery) {
        searchBusinessAnalyst(baQuery);
      }
      if (
        baQuery === "" &&
        props.formType !== "createRollout" &&
        props.formType !== "editBot"
      ) {
        setState({ ...state, businessAnalyst: "" });
      }
    }
  }, [baQuery, searchBusinessAnalyst]);


 //create ET in Bot form
  const { technology } = state;

  useEffect(() => {
    //if no ET selected in tech remove eTProfile
    if (!technology?.includes("ET")) {
      let requiredFieldsChange = requiredFieldsArray.filter(
        (item) => item !== "eTProfile"
      );
      setRequiredFieldsArray([...requiredFieldsChange]);
    }
  }, [technology]);

  //new et addition
  useEffect(() => {
    if (newlyCreatedET) {
      setState((prev) => ({ ...prev, eTProfile: newlyCreatedET }));

      const getIndexOfETProfile = props.data.findIndex(
        (item) => item.field_form_field_title === "ET Profile"
      );

      if (getIndexOfETProfile === -1) {
        return;
      }

      const existingData =
        props.data[getIndexOfETProfile].field_dropdown_option_component[0]
          .field_options;
      const newData = [newlyCreatedET, ...existingData];

      props.data[
        getIndexOfETProfile
      ].field_dropdown_option_component[0].field_options = newData;

      setNewlyCreatedET("");
    }
  }, [newlyCreatedET]);

  useEffect(() => {
    const getIndexOfETProfile = props.data.findIndex(
      (item) => item.field_form_field_title === "ET Profile"
    );

    console.log("getIndexOfETProfile", getIndexOfETProfile);

    if (getIndexOfETProfile === -1) {
      return;
    }

    const existingData =
      props.data[getIndexOfETProfile].field_dropdown_option_component[0]
        .field_options;

    const getNewETs = async () => {
      let auth;

      if (typeof window !== "undefined") {
        auth = JSON.parse(localStorage.getItem("auth")).data;
      }

      const config = {
        headers: {
          Authorization: auth.accessToken,
        },
      };

      try {
        const res = await axios.post(
          `${axiosConfig.baseUrl}/bot/get-ets`,
          { exceptETs: existingData },
          config
        );

        const ETs = res.data.data.map((item) => item.employeeTwinName);

        if (Array.isArray(ETs)) {
          const newData = [...ETs, ...existingData];
          newData.unshift("Create new ET Profile");
           console.log("newData", newData);
          props.data[
            getIndexOfETProfile
          ].field_dropdown_option_component[0].field_options = newData;
        }
      } catch (error) {
        console.log("Error", error);
      }
    };

    getNewETs();
  }, []);


  return (
    <div className={styles.mainContain}>

      {state?.eTProfile === "Create new ET Profile" && (
        <CreateETForm
          closeETForm={closeETForm}
          globalData={props.globalData}
          formDataBots={props.data}
          setNewlyCreatedET={setNewlyCreatedET}
          state={{
            leadPlatform: state.leadPlatform,
            area: state.area,
            subArea: state.subArea,
            cluster: state.cluster,
            mco: state.mco?.join(","),
            country: state.country?.join(","),
          }}
        />
      )}

      <div className={`${styles.first_container} container`}>
        <div className="row">
          {allBotFields.map((item, index) => {
            if (item.field_input_type == "Radio") {
              if (item.field_label == "KFAS Type") {
                if (state.kfa == true) {
                  return (
                    <div
                      className={`${
                        item.field_column_size == "Large"
                          ? "col-lg-8 col-md-12"
                          : "col-lg-4 col-md-6"
                      } col-12`}
                    >
                      <div
                        className={`${styles.formGroup} ${
                          item.field_column_size == "Large"
                            ? styles.fullWidth
                            : item.field_column_size == "Extra Large"
                            ? styles.maxWidth
                            : null
                        }`}
                        onChange={inputChange}
                      >
                        <label className={styles.mainLabel}>
                          <span>
                            {item.field_form_field_title}
                            <sup className={styles.mandatoryField}>*</sup>
                          </span>
                          {invalidFlag ? (
                            state["kfa"] == true &&
                            state["kfaTransactional"] == false &&
                            state["kfaInformational"] == false
                              ? (
                              <span className={styles.errorMessage}>
                                {"Please choose a KFAS type"}
                              </span>
                            ) : null
                          ) : null}
                        </label>
                        <div className={styles.inputGroupWrapper}>
                          {item.field_options.map((radioItem, index) => {
                            return (
                              <label
                                className={styles.radioWrapper}
                                key={index}
                              >
                                <span className={styles.subLabel}>
                                  {radioItem}
                                </span>
                                <input
                                  type="radio"
                                  className={styles.radioBox}
                                  value={radioItem}
                                  name={item.value}
                                  checked={
                                    (state["kfaTransactional"] == true &&
                                      radioItem == "Transactional") ||
                                    (state["kfaInformational"] == true &&
                                      radioItem == "Informational")
                                       
                                      ? true
                                      : false
                                  }
                                />
                                <span className={styles.radioCheckmark}></span>
                              </label>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                } else {
                  return null;
                }
              } else if(item.field_label=="KFAS") {
                return (
                  <div
                    className={`${
                      item.field_column_size == "Large"
                        ? "col-lg-8 col-md-12"
                        : item.field_column_size == "Extra Large"
                        ? "col-12"
                        : "col-lg-4 col-md-6"
                    } col-12`}
                  >
                    <div
                      className={`${styles.formGroup} ${
                        item.field_column_size == "Large"
                          ? styles.fullWidth
                          : item.field_column_size == "Extra Large"
                          ? styles.maxWidth
                          : null
                      }`}
                      onChange={inputChange}
                    >
                      <label className={styles.mainLabel}>
                        <span>
                          {item.field_form_field_title}
                          <sup className={styles.mandatoryField}>*</sup>
                        </span>
                      </label>
                      <div className={styles.inputGroupWrapper}>
                        {item.field_options.map((radioItem, index) => {
                          return (
                            <label className={styles.radioWrapper} key={index}>
                              <span className={styles.subLabel}>
                                {radioItem}
                              </span>
                              <input
                                type="radio"
                                className={styles.radioBox}
                                value={radioItem}
                                name={item.value}
                                checked={
                                  state[item.value] == radioItem
                                  ? true
                                  : (state[item.value] == false &&
                                      radioItem == "No") ||
                                    (state[item.value] == true &&
                                      radioItem == "Yes")
                                  ? true
                                  : false
                                }
                                // defaultChecked={
                                //   item.value == "requestType"
                                //     ? radioItem == "New Request"
                                //       ? true
                                //       : false
                                //     : item.value == "kFA"
                                //     ? radioItem == "No"
                                //       ? true
                                //       : false
                                //     : false
                                // }
                              />
                              <span className={styles.radioCheckmark}></span>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              }
              else if(item.field_label=="Catalogue Products") {
                return (
                  <div
                    className={`${
                      item.field_column_size == "Large"
                        ? "col-lg-8 col-md-12"
                        : item.field_column_size == "Extra Large"
                        ? "col-12"
                        : "col-lg-4 col-md-6"
                    } col-12`}
                  >
                    <div
                      className={`${styles.formGroup} ${
                        item.field_column_size == "Large"
                          ? styles.fullWidth
                          : item.field_column_size == "Extra Large"
                          ? styles.maxWidth
                          : null
                      }`}
                      onChange={inputChange}
                    >
                      <label className={styles.mainLabel}>
                        <span>
                          {item.field_form_field_title}
                          <sup className={styles.mandatoryField}>*</sup>
                        </span>
                        {invalidFlag ? (
                            state["catalogueProducts"] == undefined
                              ? (
                              <span className={styles.errorMessage}>
                                {"Please choose a Catalogue Products"}
                              </span>
                            ) : null
                          ) : null}
                      </label>
                      <div className={styles.inputGroupWrapper}>
                        {item.field_options.map((radioItem, index) => {
                          return (
                            <label className={styles.radioWrapper} key={index}>
                              <span className={styles.subLabel}>
                                {radioItem}
                              </span>
                              <input
                                type="radio"
                                className={styles.radioBox}
                                value={radioItem}
                                name={item.value}
                                checked={
                                  state[item.value] == radioItem
                                  ? true
                                  : (state[item.value] == false &&
                                      radioItem == "No") ||
                                    (state[item.value] == true &&
                                      radioItem == "Yes")
                                  ? true
                                  : false
                                }
                              />
                              <span className={styles.radioCheckmark}></span>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              }
             else {
                return (
                  <div
                    className={`${
                      item.field_column_size == "Large"
                        ? "col-lg-8 col-md-12"
                        : item.field_column_size == "Extra Large"
                        ? "col-12"
                        : "col-lg-4 col-md-6"
                    } col-12`}
                  >
                    <div
                      className={`${styles.formGroup} ${
                        item.field_column_size == "Large"
                          ? styles.fullWidth
                          : item.field_column_size == "Extra Large"
                          ? styles.maxWidth
                          : null
                      }`}
                      onChange={inputChange}
                    >
                      <label className={styles.mainLabel}>
                        <span>
                          {item.field_form_field_title}
                          <sup className={styles.mandatoryField}>*</sup>
                        </span>
                      </label>
                      <div className={styles.inputGroupWrapper}>
                        {item.field_options.filter((radioItem,index)=>{
                          //console.log("bhai idhar dekhle",radioItem)
                         return (props.formType=="createRollout")?radioItem=="Roll Out":((props.formType=="editBot")?radioItem:radioItem!=="Roll Out")
                        }).map((radioItem, index) => {
                          return (
                             <>
                                {radioItem !== "Change Request" && (
                                  <label
                                    className={styles.radioWrapper}
                                    key={index}
                                  >
                                    <span className={styles.subLabel}>
                                      {radioItem}
                                    </span>
                                    <input
                                      type="radio"
                                      className={styles.radioBox}
                                      value={radioItem}
                                      name={item.value}
                                      disabled={
                                        props.formType == "editBot"
                                          ? props.savedState.requestType ==
                                            "Roll Out"
                                            ? true
                                            : radioItem == "Roll Out"
                                          : false
                                      }
                                      checked={
                                        state[item.value] == radioItem
                                          ? true
                                          : (state[item.value] == false &&
                                              radioItem == "No") ||
                                            (state[item.value] == true &&
                                              radioItem == "Yes")
                                          ? true
                                          : props.formType == "createRollout"
                                          ? true
                                          : false
                                      }
                                      // defaultChecked={
                                      //   item.value == "requestType"
                                      //     ? radioItem == "New Request"
                                      //       ? true
                                      //       : false
                                      //     : item.value == "kFA"
                                      //     ? radioItem == "No"
                                      //       ? true
                                      //       : false
                                      //     : false
                                      // }
                                    />
                                    <span
                                      className={styles.radioCheckmark}
                                    ></span>
                                  </label>
                                )}
                              </>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              }
            } else if (
              item.field_input_type == "Plain Text" ||
              item.field_input_type == "Number" ||
              item.field_input_type == "Email"
            ) {

              if (item.field_label == "Business Analyst") {
                // for business analyst
                return (
                  <div
                    className={`${
                      item.field_column_size == "Large"
                        ? "col-lg-8 col-md-12"
                        : item.field_column_size == "Extra Large"
                          ? null
                          : "col-lg-4 col-md-6"
                    } col-12`}
                  >
                    <div
                      className={`${styles.inputGroup} ${
                        item.field_column_size == "Large"
                          ? styles.fullWidth
                          : item.field_column_size == "Extra Large"
                            ? styles.maxWidth
                            : null
                      }`}
                    >
                      <label>
                        <span>
                          {item.field_form_field_title}
                          <sup>*</sup>
                        </span>
                        {/* error message */}
                        {invalidFlag
                          ? (state[item.value] == "" ||
                              state[item.value] == false ||
                              state[item.value] === undefined ||
                              state[item.value] == undefined ||
                              state[item.value] == "undefined" ||
                              state[item.value] == null) && (
                              <span className={styles.errorMessage}>
                                {"Incorrect Format"}
                              </span>
                            )
                          : null}
                      </label>
                      <p
                        className={`${styles.input}  ${
                          invalidFlag
                            ? (state[item.value] == "" ||
                                state[item.value] == false ||
                                state[item.value] === undefined ||
                                state[item.value] == undefined ||
                                state[item.value] == "undefined" ||
                                state[item.value] == null) &&
                              item.field_required == "1"
                              ? styles.errorBorder
                              : null
                            : null
                        }`}
                      >
                        <input
                          type="text"
                          placeholder={item.field_title}
                          id="businessAnalyst"
                          onChange={(e) => setBaQuery(e.target.value)}
                          value={baQuery}
                        />
                      </p>
                      <div className="absolute z-50 left-0 top-[85px] max-h-[150px] shadow-md overflow-y-auto bg-white w-full flex flex-col">
                        {baIsSearching
                          ? [1, 2, 3, 4].map((item, idx) => (
                              <div
                                key={idx}
                                className={`w-full h-6 ${skeleton_style.skeleton_box}`}
                              ></div>
                            ))
                          : baResults.map((data, idx) => (
                              <div
                                key={idx}
                                onClick={() =>
                                  setBusinessAnalyst({
                                    target: {
                                      name: "businessAnalyst",
                                      value: data.email,
                                    },
                                  })
                                }
                                className="p-3 hover:bg-[rgba(0,0,0,0.1)] cursor-pointer"
                              >
                                {data.email}
                              </div>
                            ))}
                      </div>
                    </div>
                  </div>
                );
              } else if (item.field_label == "Cost Approver") {
                return (
                  <div
                    className={`${
                      item.field_column_size == "Large"
                        ? "col-lg-8 col-md-12"
                        : item.field_column_size == "Extra Large"
                        ? null
                        : "col-lg-4 col-md-6"
                    } col-12`}
                  >
                    <div
                      className={`${styles.inputGroup} ${
                        item.field_column_size == "Large"
                          ? styles.fullWidth
                          : item.field_column_size == "Extra Large"
                          ? styles.maxWidth
                          : null
                      }`}
                    >
                      <label>
                        <span>
                          {item.field_form_field_title}
                          <sup>*</sup>
                        </span>
                        {/* error message */}
                        {invalidFlag
                          ? (state[item.value] == "" ||
                              state[item.value] == false ||
                              state[item.value] === undefined ||
                              state[item.value] == undefined ||
                              state[item.value] == "undefined" ||
                              state[item.value] == null) && (
                              <span className={styles.errorMessage}>
                                {"Incorrect Format"}
                              </span>
                            )
                          : null}
                      </label>
                      <p
                        className={`${styles.input}  ${
                          invalidFlag
                            ? (state[item.value] == "" ||
                                state[item.value] == false ||
                                state[item.value] === undefined ||
                                state[item.value] == undefined ||
                                state[item.value] == "undefined" ||
                                state[item.value] == null) &&
                              item.field_required == "1"
                              ? styles.errorBorder
                              : null
                            : null
                        }`}
                      >
                        <input
                          type="text"
                          placeholder={item.field_title}
                          id="costApprover"
                          onChange={(e) => setQuery2(e.target.value)}
                          value={query2}
                        />
                      </p>

                      <div className="absolute z-50 left-0 top-[85px] max-h-[150px] shadow-md overflow-y-auto bg-white w-full flex flex-col">
                        {isSearching2
                          ? [1, 2, 3, 4].map((item, idx) => (
                              <div
                                key={idx}
                                className={`w-full h-6 ${skeleton_style.skeleton_box}`}
                              ></div>
                            ))
                          : results2.map((data, idx) => (
                              <div
                                key={idx}
                                onClick={() =>
                                  setCostApprover({
                                    target: {
                                      name: "costApprover",
                                      value: data.email,
                                    },
                                  })
                                }
                                className="p-3 hover:bg-[rgba(0,0,0,0.1)] cursor-pointer"
                              >
                                {data.email}
                              </div>
                            ))}
                      </div>
                    </div>
                  </div>
                );

                //for email searching
              } else if (item.field_label == "Business Owner Email ID") {
                return (
                  <div
                    className={`${
                      item.field_column_size == "Large"
                        ? "col-lg-8 col-md-12"
                        : item.field_column_size == "Extra Large"
                        ? null
                        : "col-lg-4 col-md-6"
                    } col-12`}
                  >
                    <div
                      className={`${styles.inputGroup} ${
                        item.field_column_size == "Large"
                          ? styles.fullWidth
                          : item.field_column_size == "Extra Large"
                          ? styles.maxWidth
                          : null
                      }`}
                    >
                      <label>
                        <span>
                          {item.field_form_field_title}
                          <sup>*</sup>
                        </span>
                        {/* error message */}
                        {invalidFlag
                          ? (state[item.value] == "" ||
                              state[item.value] == false ||
                              state[item.value] === undefined ||
                              state[item.value] == undefined ||
                              state[item.value] == "undefined" ||
                              state[item.value] == null) && (
                              <span className={styles.errorMessage}>
                                {"Incorrect Format"}
                              </span>
                            )
                          : null}
                      </label>
                      <p
                        className={`${styles.input}  ${
                          invalidFlag
                            ? (state[item.value] == "" ||
                                state[item.value] == false ||
                                state[item.value] === undefined ||
                                state[item.value] == undefined ||
                                state[item.value] == "undefined" ||
                                state[item.value] == null) &&
                              item.field_required == "1"
                              ? styles.errorBorder
                              : null
                            : null
                        }`}
                      >
                        <input
                          type="text"
                          placeholder={item.field_title}
                          id="businessOwner"
                          onChange={(e) => setQuery(e.target.value)}
                          value={query}
                        />
                      </p>

                      <div className="absolute z-50 left-0 top-[85px] max-h-[150px] shadow-md overflow-y-auto bg-white w-full flex flex-col">
                        {isSearching
                          ? [1, 2, 3, 4].map((item, idx) => (
                              <div
                                key={idx}
                                className={`w-full h-6 ${skeleton_style.skeleton_box}`}
                              ></div>
                            ))
                          : results.map((data, idx) => (
                              <div
                                key={idx}
                                onClick={() =>
                                  setBusinessOwnerEmail({
                                    target: {
                                      name: "businessOwnerEmailID",
                                      value: data.email,
                                    },
                                  })
                                }
                                className="p-3 hover:bg-[rgba(0,0,0,0.1)] cursor-pointer"
                              >
                                {data.email}
                              </div>
                            ))}
                      </div>
                    </div>
                  </div>
                );
              }else if (item.field_label == "Parent Bot ID") {
                if (state.requestType != "New Request") {
                  return (
                    <div
                      className={`${
                        item.field_column_size == "Large"
                          ? "col-lg-8 col-md-12"
                          : item.field_column_size == "Extra Large"
                          ? null
                          : "col-lg-4 col-md-6"
                      } col-12`}
                    >
                      <div
                        className={`${styles.inputGroup} ${
                          item.field_column_size == "Large"
                            ? styles.fullWidth
                            : item.field_column_size == "Extra Large"
                            ? styles.maxWidth
                            : null
                        }`}
                      >
                        <label>
                          <span>
                            {item.field_form_field_title}
                            <sup>*</sup>
                          </span>
                          {/* error message */}
                          {invalidFlag
                            ? (state[item.value] == "" ||
                                state[item.value] == false ||
                                state[item.value] === undefined ||
                                state[item.value] == undefined ||
                                state[item.value] == "undefined" ||
                                state[item.value] == null) && (
                                <span className={styles.errorMessage}>
                                  {"Incorrect Format"}
                                </span>
                              )
                            : null}
                        </label>
                        <p
                          className={`${styles.input}  ${
                            invalidFlag
                              ? (state[item.value] == "" ||
                                  state[item.value] == false ||
                                  state[item.value] === undefined ||
                                  state[item.value] == undefined ||
                                  state[item.value] == "undefined" ||
                                  state[item.value] == null) &&
                                item.field_required == "1"
                                ? styles.errorBorder
                                : null
                              : null
                          }`}
                        >
                          <input
                            type="text"
                            placeholder={item.field_title}
                            name={item.value}
                            disabled={props.formType == "createRollout"?true:false}
                            onChange={props.formType !== "createRollout" && inputChange}
                            onBlur={props.formType !== "createRollout" && hanldelinputBlur}
                            defaultValue={props.savedState.botExternalId}
                          />
                        </p>
                      </div>
                    </div>
                  );
                } else {
                  return null;
                }
              } else if (
                item.value == "commentsForStatusChanged" &&
                state.status !== "Rejected" &&
                state.status !== "On hold" &&
                state.status !== "Retired"
              ) {
                return null;
              } else {
                return (
                  <div
                    className={`${
                      item.field_column_size == "Large"
                        ? "col-lg-8 col-md-12"
                        : item.field_column_size == "Extra Large"
                        ? null
                        : "col-lg-4 col-md-6"
                    } col-12`}
                  >
                    <div
                      className={`${styles.inputGroup} ${
                        item.field_column_size == "Large"
                          ? styles.fullWidth
                          : item.field_column_size == "Extra Large"
                          ? styles.maxWidth
                          : null
                      }`}
                    >
                      <label>
                        <span>
                          
                          {item.field_form_field_title}
                          {item.field_required == "1" ? <sup>*</sup> : null}
                        </span>
                        {/* error message */}
                        {invalidFlag ? (
                          (state[item.value] == "" ||
                            state[item.value] == false ||
                            state[item.value] === undefined ||
                            state[item.value] == undefined ||
                            state[item.value] == "undefined" ||
                            state[item.value] == null) &&
                          item.field_required == "1" ? (
                            <span className={styles.errorMessage}>
                              {item.field_message_ip_error_message}
                            </span>
                          ) : 
                            item.field_input_type == "Email" &&
                            !validateEmail(state[item.value]) && emailCheck.includes(item.value) ? (
                            <span className={styles.errorMessage}>
                              Enter a valid unilever email
                            </span>
                          ) : item.field_input_type == "Number" &&
                            isNaN(state[item.value]) ? (
                            <span className={styles.errorMessage}>
                              Enter a valid number
                            </span>
                          ) : null
                        ) : null}
                      </label>
                      <p
                        className={`${styles.input}  ${
                          invalidFlag
                            ? ((state[item.value] == "" ||
                                state[item.value] == false ||
                                state[item.value] === undefined ||
                                state[item.value] == undefined ||
                                state[item.value] == "undefined" ||
                                state[item.value] == null) &&
                                item.field_required == "1") ||
                              ((item.field_input_type == "Email" &&
                                !validateEmail(state[item.value])) && emailCheck.includes(item.value) ) ||
                              (item.field_input_type == "Number" &&
                                isNaN(state[item.value]))
                              ? styles.errorBorder
                              : null
                            : null
                        }`}
                      >
                        <input
                          type="text"
                          placeholder={ item.value == "createdBy" ? "": item.field_title}
                          name={item.value}
                          onChange={inputChange}
                          value={
                            item.value !== "createdBy"
                              ? state[item.value] ? state[item.value] : ""
                              : (props.formType == "editBot")
                              ? state[item.value]
                              : auth.name ? auth.name : auth.email
                          }
                          
                          disabled={item.value == "createdBy"  || (item.value == "landscapeApprover" && state.landscapeApproval == "No") || (item.value == "infosecApprover" && state.infosecApproval == "No") ?  true : false}
                        />
                      </p>
                      {item.value == "processID" ? (
                        <span className={styles.fieldFormat}>
                          {
                            "e.g. UL<BP/AA/UI> <3 letter Lead Platform> <3 letter sub area> <1 letter SAP landscape C/S/F/U> <3 digit ID> <Process description> </Process>"
                          }
                        </span>
                      ) : null}
                    </div>
                  </div>
                );
              }
            } else if (
              item.field_input_type == "Dropdown" ||
              item.field_input_type == "Related Dropdown"
            ) {
              


              return (
                <div
                  className={`${
                    item.field_column_size == "Large"
                      ? "col-lg-8 col-md-12"
                      : "col-lg-4 col-md-6"
                  } col-12`}
                   style={{
                      display:
                        item.field_label === "ET Profile" &&
                        !state["technology"].includes("ET")
                          ? "none"
                          : "block",
                   }}

                >
                   <div
                      style={{
                        display:
                          item.field_label === "ET Profile" &&
                          !state["technology"].includes("ET")
                            ? "none"
                            : "block",
                      }}
                      className={styles.inputGroup}
                    >
                    <label>
                      <span>
                        {item.field_form_field_title}
                        {item.field_required == "1" ? <sup>*</sup> : null}
                      </span>
                      {/* error message */}
                      {invalidFlag ? (
                        (state[item.value] == "" ||
                          
                          state[item.value] === undefined ||
                          state[item.value] == undefined ||
                          state[item.value] == "undefined" ||
                          state[item.value] == null) &&
                        item.field_required == "1" ? (
                          <span className={styles.errorMessage}>
                            {item.field_message_ip_error_message}
                          </span>
                        ) : null
                      ) : null}
                    </label>
                    <p
                      style={{cursor:"pointer"}}
                      className={`${styles.input} ${
                        invalidFlag
                          ? (state[item.value] == "" ||
                             
                              state[item.value] === undefined ||
                              state[item.value] == undefined ||
                              state[item.value] == "undefined" ||
                              state[item.value] == null) &&
                            item.field_required == "1"
                            ? styles.errorBorder
                            : null
                          : null
                      }`}
                      onClick={() => {
                        // ((props.formType == "editBot") && (item.field_label == "Landscape"))?void(0):
                         handleDropDown(item.value);
                      }}
                    >
                      <span className={styles.left}>
                       {state[item.value] == null ||
                          state[item.value] == "undefined" ||
                          state[item.value] === "" ||
                          state[item.value] === undefined
                            ? item.field_input
                            : item.field_label == "Country"
                            ? state.country != undefined &&
                              state.country != null
                              ? state.country.length == 0
                                ? item.field_input
                                : `${state.country.length} items selected`
                              : item.field_input
                            : item.field_label == "MCO"
                            ? state.mco != undefined && state.mco != null
                              ? state.mco.length == 0
                                ? item.field_input
                                : `${state.mco.length} items selected`
                              : item.field_input
                            : item.field_label == "Technology"
                            ? state.technology != undefined &&
                              state.technology != null
                              ? state.technology.length == 0
                                ? item.field_input
                                : `${state.technology.length} items selected`
                              : item.field_input
                            : state[item.value]}
                      </span>
                      {auth.userType != "supportStatus" ? item.field_label != "Support Status" ?
                      <span className={styles.right}>
                        <Icons name="chevron" className={styles.chevron} />
                      </span> :null:
                      <span className={styles.right}>
                      <Icons name="chevron" className={styles.chevron} />
                    </span>}
                    </p>
                    {dropDownState[item.value] == true ? (
                      item.field_label == "Country" ? (
                        <CheckboxDropdown
                          values={
                            item.field_input_type == "Related Dropdown"
                              ? relatedDropdowns[item.value].nowValues !=
                                undefined
                                ? [
                                    // "None",
                                    ...relatedDropdowns[item.value].nowValues,
                                  ]
                                : ["No parent Selected"]
                              : [
                                  // "None",
                                  ...item.field_options,
                                ]
                          }
                          removeCheckedValue={removeCheckedValue}
                          presentState={state.country}
                          getDropdownValue={gotDropDownValue}
                          haveRelated={
                            item.field_related_dropdown == "MCO"
                              ? "mco"
                              : camelize(item.field_related_dropdown)
                          }
                          dropdownParent={item.value}
                        />
                      ) 
                      :item.field_label == "MCO" ? (
                      <CheckboxDropdown
                        values={
                          item.field_input_type == "Related Dropdown"
                            ? relatedDropdowns[item.value].nowValues !=
                              undefined
                              ? [
                                  // "None",
                                  ...relatedDropdowns[item.value].nowValues,
                                ]
                              : ["No parent Selected"]
                            : [
                                // "None",
                                ...item.field_options,
                              ]
                        }
                        removeCheckedValue={removeCheckedValue}
                        presentState={state.mco}
                        getDropdownValue={gotDropDownValue}
                        haveRelated={camelize(item.field_related_dropdown)}
                        dropdownParent={item.value}
                      />) : item.field_label == "Technology" ? (
                          <CheckboxDropdown
                            values={
                              item.field_input_type == "Related Dropdown"
                                ? relatedDropdowns[item.value].nowValues !=
                                  undefined
                                  ? [
                                      // "None",
                                      ...relatedDropdowns[item.value].nowValues,
                                    ]
                                  : ["No parent Selected"]
                                : [
                                    // "None",
                                    ...item.field_options,
                                  ]
                            }
                            removeCheckedValue={removeCheckedValue}
                            presentState={state.technology}
                            getDropdownValue={gotDropDownValue}
                            haveRelated={camelize(item.field_related_dropdown)}
                            dropdownParent={item.value}
                          />
                        )
                       : (
                        <DropDown
                          dropdownParent={item.value}
                          values={
                            item.field_input_type == "Related Dropdown"
                              ? relatedDropdowns[item.value].nowValues !=
                                undefined
                                ? [
                                    // "None",
                                    ...relatedDropdowns[item.value].nowValues,
                                  ]
                                : ["No parent Selected"]
                              : [
                                  // "None",
                                  ...item.field_options,
                                ]
                          }
                          getDropdownValue={gotDropDownValue}
                          // haveRelated={"mco"}
                          haveRelated={
                            item.field_related_dropdown == "MCO"
                              ? "mco"
                              : camelize(item.field_related_dropdown)
                          }
                          closeAllDropdowns={() => {
                            setDropdownState(dropDownsInitialStates);
                          }}
                        />
                      )
                    ) : null}
                    {/* {item.field_label == "Country"
                      ? state[item.value].map((multipleItem, index) => (
                          <span key={index} className={styles.multipleItems}>
                            {multipleItem}
                          </span>
                        ))
                      : null} */}
                  </div>
                </div>
              );
            } else if (item.field_input_type == "Date") {
              if (
                (item.value == "dateOfStatusChanged" &&
                  state.status !== "Rejected" &&
                  state.status !== "On hold" &&
                  state.status !== "Retired") ||
                (item.value == "goLiveDate" && state.status !== "Live")
              ) {
                return null;
              } else {
                return (
                  <div
                    className={`${
                      item.field_column_size == "Large"
                        ? "col-lg-8 col-md-12"
                        : "col-lg-4 col-md-6"
                    } col-12`}
                  >
                    <div className={`${styles.inputGroup} `}>
                      <label>
                        <span>
                          
                          {item.field_form_field_title}
                          {item.field_required == "1" ? <sup>*</sup> : null}
                        </span>
                        {/* error message */}
                        {invalidFlag ? (
                          (state[item.value] == "" ||
                            state[item.value] == false ||
                            state[item.value] === undefined ||
                            state[item.value] == undefined ||
                            state[item.value] == "undefined" ||
                            state[item.value] == null) &&
                          item.field_required == "1" ? (
                            <span className={styles.errorMessage}>
                              Incorrect Format
                            </span>
                          ) : null
                        ) : null}
                      </label>
                      <Datetime
                        closeOnSelect={true}
                        // initialValue={_.get(state, "dateLogged", [
                        //   "2020-11-12",
                        // ])}
                        closeOnClickOutside={true}
                        value={
                          state[item.value] &&
                          state[item.value] !== "" &&
                          state[item.value] !== "undefined"
                            ? convertToDDMMYYYY(state[item.value])
                            : null
                        }
                        // initialValue={_get(state, item.value, Date.now())}
                        timeFormat={false}
                        dateFormat={"DD-MM-YYYY"}
                        className={`${styles.calender}  ${
                          invalidFlag
                            ? (state[item.value] == "" ||
                                state[item.value] == false ||
                                state[item.value] === undefined ||
                                state[item.value] == undefined ||
                                state[item.value] == "undefined" ||
                                state[item.value] == null) &&
                              item.field_required == "1"
                              ? styles.errorBorder
                              : null
                            : null
                        }`}
                        inputProps={{
                          placeholder: "DD-MM-YYYY",
                          readOnly: true,
                          disabled:
                            item.value == "dateLogged" ||
                            item.value == "dateOfStatusChanged"
                              ? true
                              : false,
                        }}
                        onChange={(date) => handleDate(date, item.value)}
                      />
                    </div>
                  </div>
                );
              }
            }
          })}
        </div>
      </div>
      {props.pageNum == 2 ? (
        <UploadDocuments
          sendDocInfo={gotDocInfo}
          editState={state}
          formType={props.formType}
          saveUploadDocumentStateInRedux={gotUploadDocumentsState}
          savedState={props.savedState}
          deleteDemoVideo={deleteDemoVideo}
          sopInvalid={sopInvalid}
          setSopInvalid={setSopInvalid}
        />
      ) : null}
      <div className="container mb-3">
        <div className={styles.buttonBody}>
          <div className={styles.previousBtn}>
            {props.pageNum != 1 ? (
              <span className={styles.prevBtn} onClick={goBack}>
                <Icons name="arrowback" className={styles.backarrow} /> Previous
              </span>
            ) : null}
          </div>
          <div className={styles.combinedBtn}>
            <span className={styles.rowBtn} onClick={botback}>
              Cancel
            </span>

            <span className={styles.exportListBtn} onClick={botSecond}>
              {props.pageNum == 4
                ? props.formType == "editBot"
                  ? "Submit"
                  : "Preview Details"
                : "Save and Proceed"}
            </span>
          </div>
          {loading  ? <Loader /> : null
            
        }
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentBot: state.storeBot.currentBot,
});

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);


